module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0610.f20bf789.jpg";